<template>
  <div :class="$options.name">
    <v-card>
      <v-toolbar color="blue darken-3" dark flat>
        <v-btn
          v-permission="['layer-collection-create']"
          class="primary"
          @click="$dialog.show('attachments-dialog')"
        >
          Добавить
        </v-btn>
        <div class="flex-grow-1" />
        <v-text-field
          v-model="search"
          label="Поиск по типу"
          prepend-inner-icon="search"
          flat
          clearable
          single-line
          hide-details
        />
      </v-toolbar>
      <v-data-table
        :items="list"
        :headers="headers"
        :loading="isLoading"
        hide-default-footer
      >
        <template #item.layerObjects="{ item }">
          {{ item.layerObjects.length }} типов файлов
        </template>
        <template #item.actions="{ item }">
          <div class="data-table-actions">
            <v-btn
              v-permission="['layer-collection-edit']"
              color="light"
              :class="{ w100: $vuetify.breakpoint.lgAndDown }"
              x-small
              @click="$dialog.show('attachments-dialog', { item })"
            >
              <v-icon left>edit</v-icon> Редактировать
            </v-btn>

            <v-btn
              v-permission="['layer-collection-delete']"
              color="error"
              class="ml-2"
              :class="{ w100: $vuetify.breakpoint.lgAndDown }"
              x-small
              @click="$dialog.show('remove-layer-collection-confirmation', { itemId: item.id })"
            >
              <v-icon left>delete</v-icon> Удалить
            </v-btn>
          </div>
        </template>

        <template v-if="pagination" #footer>
          <v-pagination
            :length="pagination.lastPage"
            :total-visible="8"
            :value="pagination.currentPage"
            :disabled="pagination.lastPage === 1"
            color="blue darken-3"
            class="pb-4 pt-4"
            @input="onChangePage($event)"
          />
        </template>
      </v-data-table>
    </v-card>
    <attachments-dialog />
    <remove-confirmation
      name="remove-layer-collection-confirmation"
      title="Вы действительно желаете удалить элемент?"
      @confirmed="onRemove"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import debounce from 'lodash/debounce';
import RemoveConfirmation from '@/components/dialogs/confirmations/RemoveConfirmation.vue';
import AttachmentsDialog from './components/AttachmentsDialog.vue';

export default {
  name: 'attachments-list',
  asyncData({ store }) {
    const actions = [
      store.dispatch('attachments/getList'),
      store.dispatch('attachments/getAvailableTypes'),
    ];

    return Promise.all(actions);
  },

  components: { RemoveConfirmation, AttachmentsDialog },

  data: () => ({
    isLoading: false,
    headers: [
      { value: 'name', text: 'Название', sortable: false },
      { value: 'fileType', text: 'Расширение', sortable: false },
      { value: 'maxFileSizeMb', text: 'Максимальный размер файла, Мб', sortable: false },
      {
        value: 'actions',
        sortable: false,
        width: '30%',
        align: 'right',
      },
    ],
    search: '',
  }),

  computed: {
    ...mapState('attachments', ['list', 'pagination']),

    formattedHappenedAt() {
      return (item) => moment(item.happenedAt).format('DD.MM.YYYY HH:mm');
    },
  },

  watch: {
    // eslint-disable-next-line func-names
    search: debounce(async function () {
      this.isLoading = true;
      await this.getList({ query: this.search });
      this.isLoading = false;
    }, 750),
  },

  methods: {
    ...mapActions('attachments', ['getNextPage', 'remove', 'getList']),

    async onChangePage(page) {
      this.isLoading = true;
      await this.getNextPage({ page });
      this.isLoading = false;
    },

    async onRemove(id) {
      this.isLoading = true;
      await this.remove(id);
      this.isLoading = false;
    },
  },

};
</script>
